import React, { useState } from 'react'
import { auth, provider } from '../firebase';
import { signInWithPopup , sendPasswordResetEmail, signInWithEmailAndPassword, createUserWithEmailAndPassword} from 'firebase/auth'
import { collection, addDoc, updateDoc, getDoc, doc, setDoc, getDocs, onSnapshot, query, where } from 'firebase/firestore';
import { useAuthState } from 'react-firebase-hooks/auth';
import { async } from '@firebase/util';
import { FcGoogle } from 'react-icons/fc';


const SignIn = () => {

  const [user] = useAuthState(auth)
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [errorMessage, setErrorMessage] = useState(null)
  const [signUpMessage, setSignUpMessage] = useState("")
  const [showManual, setShowManual] = useState(false)
  const [showForgotDialog, setShowForgotDialog] = useState(false)
  const [resetMessage, setResetMessage] = useState("Password reset email will be sent your email address")
  const [message, setMessage] = useState('');
  const [showSignUpDialog, setShowSignUpDialog] = useState(false)

  const handleResetPassword = async () => {
    try {
      await sendPasswordResetEmail(auth, email);
      setResetMessage('Password reset email sent. Please check your inbox.');
    } catch (error) {
      switch (error.code) {
        case 'auth/invalid-email':
          setResetMessage('Invalid email address. Please enter a valid email.');
          break;
        case 'auth/user-not-found':
          setResetMessage('User not found. Please check your email address.');
          break;
        default:
          setResetMessage('An error occurred. Please try again later.');
          break;
      }
    }
  };


  function signInWithGoogle() {

    signInWithPopup(auth, provider)
    .catch((e)=>console.log(e.errorMessage))
     

  }

  const handleSignUpWithEmail = async () => {

    try { await createUserWithEmailAndPassword(auth, email, password)
    } catch (error) {

      switch (error.code) {
        case 'auth/invalid-email':
          setSignUpMessage('Invalid email address. Please enter a valid email.');
          break;
        case 'auth/missing-password':
          setSignUpMessage('Invalid password.');
          break;
        case 'auth/user-not-found':
          setSignUpMessage('User not found. Please check your email address.');
          break;
        case 'auth/wrong-password':
          setSignUpMessage('Incorrect password. Please try again.');
          break;
        case 'auth/email-already-in-use':
          setSignUpMessage('Email is already in use. Please sign in or reset your password.');
          break;
        default:
          setSignUpMessage('An error occurred. Please try again later.');
          break;
      }
    };
    
  }

  const handleSignInWithEmail = async () => {

    try { await signInWithEmailAndPassword(auth, email, password)}
    catch(error){
      switch (error.code) {
        case 'auth/invalid-email':
          setMessage('Invalid email address. Please enter a valid email.');
          break;
        case 'auth/missing-password':
          setMessage('Invalid password.');
          break;
        case 'auth/user-not-found':
          setMessage('User not found. Please check your email address.');
          break;
        case 'auth/wrong-password':
          setMessage('Incorrect password. Please try again.');
          break;
        case 'auth/email-already-in-use':
          setMessage('Email is already in use. Please sign in or reset your password.');
          break;
        default:
          setMessage('An error occurred. Please try again.');
          break;
      }

    }
   

  
  }

  const SignUpDialog = () => {
    return (
      <div className='overlay'>
        <div className='dialog'>
          <h2>Create your account</h2>
          
            E-mail <input style={{"marginBottom":"10px"}} type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
          
            Password <input style={{"marginBottom":"10px"}} type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
            
            Password (confirmation) <input style={{"marginBottom":"10px"}} type="password" value={password2} onChange={(e) => setPassword2(e.target.value)} />
            {signUpMessage&&<h4 className='req'>{signUpMessage}</h4>}
        <div className='h-list even'>
                  <button className='btn negative' onClick={()=>{setShowSignUpDialog(false)}}>Cancel</button>
                <button className={`btn inactive ${password!=""&&password==password2&&"positive"}`} onClick={handleSignUpWithEmail}>Sign up</button>

                </div>
        </div>
      </div>
    )
  }

  
      return (
          
        <div className='main'>

        {showSignUpDialog&&<div className='overlay'>
        <div className='dialog'>
          <h2>Create your account</h2>
          
            E-mail <input style={{"marginBottom":"10px"}} type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
          
            Password <input style={{"marginBottom":"10px"}} type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
            
            Password (confirmation) <input style={{"marginBottom":"10px"}} type="password" value={password2} onChange={(e) => setPassword2(e.target.value)} />
            {signUpMessage&&<h4 className='req'>{signUpMessage}</h4>}
        <div className='h-list even'>
                  <button className='btn negative' onClick={()=>{setShowSignUpDialog(false)}}>Cancel</button>
                <button className={`btn inactive ${password!=""&&password==password2&&"positive"}`} onClick={()=>{if(password==password2){handleSignUpWithEmail()}else{setSignUpMessage("You entered different passwords")}}}>Sign up</button>

                </div>
        </div>
      </div>}

        <h2>Sign in</h2>
       
        <h3>
            E-mail <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
        <br/>
            Password <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
        </h3>
        <h4 className='req'>{message}</h4>
        <div className=''>
        

          {
            showForgotDialog&&
            <div className='overlay'>
              <div className='dialog'>
                <h2 style={{"marginBottom":"0px"}}>Reset Password</h2>
                {resetMessage&&<h5>{resetMessage}</h5>}
                <input
                
                  type="email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              
                <div className='h-list even'>
                  <button className='btn negative' onClick={()=>{setShowForgotDialog(false)}}>Cancel</button>
                <button className="btn positive" onClick={handleResetPassword}>Reset Password</button>

                </div>

              </div>
            </div>
          
          }

      
       
    </div>
        
       
        
        <div className='signin-options'>
        <button className='btn positive' onClick={handleSignInWithEmail}>
            Sign in
        </button>
        <button className='text-btn forgot' onClick={()=>{setShowForgotDialog(true)}} >Forgot Password?</button>
        

        <button className='text-btn forgot' onClick={()=>{setShowSignUpDialog(true)}}>
            Create a new account
        </button>

        <button style={{"marginTop":"30px"}} className='btn google' onClick={()=>{signInWithGoogle()}}><FcGoogle/>Sign in with Google</button>

        </div>
      
            
         

          {//<button className='g-login' onClick={signInWithGoogle}>Sign in with Google</button>
          }
          

    </div>
    
    
  )
}

export default SignIn